import auth from './modules/auth'
import companies from './modules/companies'
import reports from './modules/reports'
import sync from './modules/sync'
import users from './modules/users'
import profiles from './modules/profiles'

export default {
  auth,
  companies,
  reports,
  sync,
  users,
  profiles,
}
